class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

 document.addEventListener('click', function (e) {
  const button = e.target.closest('.add-to-cart');

  if (!button) return;
  e.preventDefault();

  if (button.classList.contains('disable')) return;

  const get_id = e.target.closest('.product-form').querySelector('input[name="id"]').value;
  const get_quantity = parseInt(e.target.closest('.product-form').querySelector('input[name="quantity"]').value);
  const items = [{ id: get_id, quantity: get_quantity }];

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({ items }),
  })
    .then(res => res.text())
    .then(() => {

      document.querySelector('#CartDrawer').classList.add('open');

      fetch(window.location.pathname + '?sections=cart-drawer')
        .then(res => res.json())
        .then(data => {
                  const cartHTML = data['cart-drawer'];
                  if (cartHTML) {
                    const doc = new DOMParser().parseFromString(cartHTML, 'text/html');
                    const newInner = doc.querySelector('#CartDrawer')?.innerHTML;

                    if (newInner) {
                      document.querySelector('#CartDrawer').innerHTML = newInner;
                    }
                  }
                   fetch('/cart.js')
                  .then((res) => res.json())
                  .then((cart) => {

                    let bubbles = document.querySelectorAll('.cart-count');
                    if (bubbles.length === 0) {
                      const bubbleDiv = document.createElement('div');
                      bubbleDiv.className = 'cart-count';
                      bubbleDiv.setAttribute('aria-live', 'polite');
                      bubbleDiv.setAttribute('aria-atomic', 'true');
                      bubbleDiv.setAttribute('id', 'cart-icon-bubble');
                      bubbleDiv.innerHTML = `
                        <span aria-hidden="true">${cart.item_count}</span>
                        <span class="visually-hidden">${cart.item_count} items</span>
                      `;
                      const cartIcons = document.querySelector('[data-cart-drawer-open]');
                      if (cartIcons) {
                        cartIcons.appendChild(bubbleDiv.cloneNode(true));
                      } else {
                        document.body.appendChild(bubbleDiv);
                      }
                      if (cart.item_count > 9) {
                        bubbleDiv.classList.add('double_bubble');
                      }
                    } else {
                      bubbles.forEach((bubble) => {
                        const visibleSpan = bubble.querySelector('span[aria-hidden="true"]');
                        const hiddenSpan = bubble.querySelector('.visually-hidden');
                        if (visibleSpan) visibleSpan.textContent = cart.item_count;
                        if (hiddenSpan) hiddenSpan.textContent = `${cart.item_count} items`;
                        if (cart.item_count > 9) {
                          bubble.classList.add('double_bubble');
                        }
                      });
                    }
                    if(cart.item_count == 0){
                      document.querySelector('.cart-count').style.display = 'none';
                    }else{
                      document.querySelector('.cart-count').style.display = 'block';
                    }
                  })
                  .catch((err) => {
                    console.error('Failed to update cart drawer section:', err);
                    clearInterval(intervalId);
                  });
          // Now open drawer
          // document.querySelector('#CartDrawer').classList.add('open');
        });
    })
    .catch(err => console.error('Error adding products:', err));
});

 document.addEventListener('click', function (e) {
    const button = e.target.closest('[data-cart-drawer-open]');
    if (!button) return;
    e.preventDefault();
    // Now open drawer
    document.querySelector('#CartDrawer').classList.add('open');
    document.body.classList.add('overflow');
 })
 document.addEventListener('click', function (e) {
    const button = e.target.closest('.cart-drawer__close');
    if (!button) return;
    e.preventDefault();
    // Now open drawer
    document.querySelector('#CartDrawer').classList.remove('open');
    document.body.classList.remove('overflow');
 })
 document.addEventListener('click', function (e) {
    const button = e.target.closest('.cart-drawer__overlay');
    if (!button) return;
    e.preventDefault();
    // Now open drawer
    document.querySelector('#CartDrawer').classList.remove('open');
    document.body.classList.remove('overflow');
 })


//  Remove Button
document.addEventListener('click', function (e) {

const button = e.target.closest('.remove-btn');
if (!button) return;
e.preventDefault();

if (button.classList.contains('disabled_btn')) return;
const itemEl = e.target.closest('.cart-drawer__item');
const get_id = itemEl?.getAttribute('data-id');
if (!get_id) return;

const items = [{ id: get_id, quantity: 0 }];

fetch('/cart/change.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  body: JSON.stringify({
        id: get_id,
        quantity: 0
      }),
})
  .then((res) => res.text())
  .then(() => {
    // Fetch updated cart drawer section
    if(document.body.classList.contains('template_cart')){
        fetch(window.location.pathname + '?sections=cart')
          .then((res) => res.json())
          .then((data_add) => {
            const cartHTML = data_add['cart'];
            console.log(data_add,'cartHTMLcartHTML');
            if (cartHTML) {
              const doc = new DOMParser().parseFromString(cartHTML, 'text/html');
              const newInner = doc.querySelector('#CartDrawer')?.innerHTML;

              if (newInner) {
                document.querySelector('#CartDrawer').innerHTML = newInner;
              }
            }
          });
    }else{
      fetch(window.location.pathname + '?sections=cart-drawer')
        .then((res) => res.json())
        .then((data) => {
          const cartHTML = data['cart-drawer'];

          if (cartHTML) {
            const doc = new DOMParser().parseFromString(cartHTML, 'text/html');
            const newInner = doc.querySelector('#CartDrawer')?.innerHTML;

            if (newInner) {
              document.querySelector('#CartDrawer').innerHTML = newInner;
            }
          }
        });
      }
      // Re-open drawer
        document.querySelector('#CartDrawer')?.classList.add('open');
        document.body.classList.remove('overflow');
      // Update cart bubble
        fetch('/cart.js')
          .then((res) => res.json())
          .then((cart) => {
            let bubbles = document.querySelectorAll('.cart-count');

            if (bubbles.length === 0) {
              const bubbleDiv = document.createElement('div');
              bubbleDiv.className = 'cart-count';
              bubbleDiv.id = 'cart-icon-bubble';
              bubbleDiv.setAttribute('aria-live', 'polite');
              bubbleDiv.setAttribute('aria-atomic', 'true');

              bubbleDiv.innerHTML = `
                <span aria-hidden="true">${cart.item_count}</span>
                <span class="visually-hidden">${cart.item_count} items</span>
              `;

              const cartIcons = document.querySelector('[data-cart-drawer-open]');
              if (cartIcons) {
                cartIcons.appendChild(bubbleDiv.cloneNode(true));
              } else {
                document.body.appendChild(bubbleDiv);
              }

              if (cart.item_count > 9) {
                bubbleDiv.classList.add('double_bubble');
              }
            } else {
              bubbles.forEach((bubble) => {
                const visibleSpan = bubble.querySelector('span[aria-hidden="true"]');
                const hiddenSpan = bubble.querySelector('.visually-hidden');

                if (visibleSpan) visibleSpan.textContent = cart.item_count;
                if (hiddenSpan) hiddenSpan.textContent = `${cart.item_count} items`;

                if (cart.item_count > 9) {
                  bubble.classList.add('double_bubble');
                } else {
                  bubble.classList.remove('double_bubble');
                }
              });
            }
            if(cart.item_count == 0){
              document.querySelector('.cart-count').style.display = 'none';
            }else{
              document.querySelector('.cart-count').style.display = 'block';
            }
          })
          .catch((err) => {
            console.error('Failed to update cart count:', err);
          });

  })
  .catch((err) => console.error('Error removing product:', err));
});


// Quantity Click
document.body.addEventListener("click", function (e) {
  const btn = e.target.closest(".quantity__button");
  if (!btn) return;

  e.preventDefault();

  const wrapper = btn.closest(".quantity");
  if (!wrapper) return;

  const input = wrapper.querySelector(".quantity__input");
  if (!input) return;

  const min = parseInt(input.dataset.min) || 1;
  const max = parseInt(input.dataset.max) || Infinity;

  let current = parseInt(input.value) || min;

  // increase / decrease
  if (btn.classList.contains("plus") || btn.dataset.action === "plus") {
    if (current < max) {
      current += 1;
    }
  }

  if (btn.classList.contains("minus") || btn.dataset.action === "minus") {
    if (current > min) {
      current -= 1;
    }
  }

  input.value = current;

  const plusBtn = wrapper.querySelector(".quantity__button.plus");
  if (plusBtn) {
    if (current >= max) {
      plusBtn.disabled = true;
      plusBtn.classList.add("disabled");
    } else {
      plusBtn.disabled = false;
      plusBtn.classList.remove("disabled");
    }
  }


  // Update cart qty
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      id: btn.closest('.cart-drawer__item').getAttribute("data-id"),
      quantity: current
    }),
  })
    .then(r => r.text())
    .then(text => JSON.parse(text))
    .then(data => {

      // If on cart page
       
      if (document.body.classList.contains('template_cart')) {
       
        fetch(window.location.pathname + '?sections=cart')
          .then((res) => res.json())
          .then((data_add) => {
            const cartHTML = data_add['cart'];
            console.log(data_add,'cartHTMLcartHTML');
            if (cartHTML) {
              const doc = new DOMParser().parseFromString(cartHTML, 'text/html');
              const newInner = doc.querySelector('#CartDrawer')?.innerHTML;

              if (newInner) {
                document.querySelector('#CartDrawer').innerHTML = newInner;
              }
            }
          });

      } else {
        fetch(window.location.pathname + '?sections=cart-drawer')
          .then((res) => res.json())
          .then((data) => {
            const cartHTML = data['cart-drawer'];

            if (cartHTML) {
              const doc = new DOMParser().parseFromString(cartHTML, 'text/html');
              const newInner = doc.querySelector('#CartDrawer')?.innerHTML;

              if (newInner) {
                document.querySelector('#CartDrawer').innerHTML = newInner;
              }
            }
          });
      }

      // Re-open drawer
      document.querySelector('#CartDrawer')?.classList.add('open');
      document.body.classList.remove('overflow');

      // Update cart bubble
      fetch('/cart.js')
        .then((res) => res.json())
        .then((cart) => {
          let bubbles = document.querySelectorAll('.cart-count');

          if (bubbles.length === 0) {
            const bubbleDiv = document.createElement('div');
            bubbleDiv.className = 'cart-count';
            bubbleDiv.id = 'cart-icon-bubble';
            bubbleDiv.setAttribute('aria-live', 'polite');
            bubbleDiv.setAttribute('aria-atomic', 'true');

            bubbleDiv.innerHTML = `
                <span aria-hidden="true">${cart.item_count}</span>
                <span class="visually-hidden">${cart.item_count} items</span>
              `;

            const cartIcons = document.querySelector('[data-cart-drawer-open]');
            if (cartIcons) {
              cartIcons.appendChild(bubbleDiv.cloneNode(true));
            } else {
              document.body.appendChild(bubbleDiv);
            }

            if (cart.item_count > 9) {
              bubbleDiv.classList.add('double_bubble');
            }
          } else {
            bubbles.forEach((bubble) => {
              const visibleSpan = bubble.querySelector('span[aria-hidden="true"]');
              const hiddenSpan = bubble.querySelector('.visually-hidden');

              if (visibleSpan) visibleSpan.textContent = cart.item_count;
              if (hiddenSpan) hiddenSpan.textContent = `${cart.item_count} items`;

              if (cart.item_count > 9) {
                bubble.classList.add('double_bubble');
              } else {
                bubble.classList.remove('double_bubble');
              }
            });
          }
          if(cart.item_count == 0){
            document.querySelector('.cart-count').style.display = 'none';
          }else{
            document.querySelector('.cart-count').style.display = 'block';
          }
        })
        .catch(err => console.error("Cart update error:", err));

    }) // ← Missing before
    .catch(err => console.error("Fetch error:", err)); 

}); 

  // Run on load and resize
  // window.addEventListener('load', handleEqualHeights);
  // window.addEventListener('resize', handleEqualHeights);

// document.addEventListener("DOMContentLoaded", () => {
//   const mainBtn = document.querySelector('.main_add_to_cart:not(.mobile_only)');
//   const mobileBtn = document.querySelector('.main_add_to_cart.mobile_only');

//   if (!mainBtn || !mobileBtn) return;

//   const observer = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         // Main button IS visible → hide mobile button
//         mobileBtn.style.display = "none";
//       } else {
//         // Main button is NOT visible → show mobile button
//         mobileBtn.style.display = "flex";
//       }
//     });
//   }, { threshold: 0 });

//   observer.observe(mainBtn);
// });

// search input typewriter effect-----------------

document.addEventListener('DOMContentLoaded', function () {
  const input = document.getElementById('SearchInput');
  if (!input) return;

  const prefix = 'Search for ';
  const words = [
    'Green Saree',
    'Purple Saree',
    'Jacquard Saree',
    'Cotton Saree'
  ];

  let wordIndex = 0;
  let charIndex = 0;
  let isDeleting = false;

  function typeEffect() {
    const currentWord = words[wordIndex];

    if (!isDeleting) {
      charIndex++;
    } else {
      charIndex--;
    }

    input.placeholder = prefix + currentWord.substring(0, charIndex);

    let speed = isDeleting ? 50 : 80;

    if (!isDeleting && charIndex === currentWord.length) {
      speed = 500; // pause after full word
      isDeleting = true;
    } 
    else if (isDeleting && charIndex === 0) {
      isDeleting = false;
      wordIndex = (wordIndex + 1) % words.length;
      speed = 200;
    }

    setTimeout(typeEffect, speed);
  }

  typeEffect();
});

// end search input typewriter effect-----------------

